import React, { useState } from 'react';

function ExampleBox({ example }) {
  const [show, setShow] = useState(false);
  return (
    <div style={{
      marginTop: '0.7rem',
      background: '#e5e5e3',
      border: '1px solid #2c2c2c',
      borderRadius: 0,
      padding: '0.7rem 1rem',
      fontSize: '0.98rem',
      fontFamily: "'Times New Roman', Times, serif",
      boxShadow: '2px 2px 0px rgba(0,0,0,0.2)'
    }}>
      <b style={{ fontFamily: "'Times New Roman', Times, serif", color: '#2c2c2c' }}>Exemplo de pista:</b>
      <span style={{ fontStyle: 'italic', fontFamily: "'Times New Roman', Times, serif" }}>{example.clue}</span><br/>
      <button
        onClick={() => setShow(s => !s)}
        style={{
          margin: '0.5rem 0',
          fontSize: '0.97rem',
          padding: '0.4rem 0.8rem',
          borderRadius: 0,
          border: '2px solid #000',
          background: '#2c2c2c',
          color: '#f8f8f6',
          cursor: 'pointer',
          fontFamily: "'Times New Roman', Times, serif",
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '1px',
          boxShadow: '2px 2px 0px rgba(0,0,0,0.3)'
        }}
      >
        {show ? 'Ocultar resposta' : 'Mostrar resposta'}
      </button>
      {show && (
        <div style={{ fontFamily: "'Times New Roman', Times, serif" }}>
          <b style={{ color: '#2c2c2c' }}>Resposta:</b> {example.answer}<br/>
          <span style={{ color: '#666', fontStyle: 'italic' }}>{example.explanation}</span>
        </div>
      )}
    </div>
  );
}


const indicators = [
  {
    title: 'Anagramas',
    content: 'Misture as letras do sopa para formar a resposta. O indicador deve estar próximo da sopa de letras.',
    indicators: ['misturado', 'bagunçado', 'estranho', 'alterado', 'modificado', 'embaralhado'],
    example: {
      clue: 'Raul parecia um reflexo do Sol (4)',
      answer: 'LUAR',
      explanation: 'Anagrama de "Raul" que significa um reflexo do Sol.'
    }
  },
  {
    title: 'Seletores',
    content: 'Pegue letras específicas (iniciais, finais, etc).',
    indicators: ['primeira', 'última', 'inicial', 'final', 'começo', 'fim', 'extremos'],
    example: {
      clue: 'Animal fica atrás de gente assustada tentando orar (4)',
      answer: 'GATO',
      explanation: 'Pegue as iniciais de Cada Palavra (Gente Assustada Tentando Orar) para formar um animal.'
    }
  },
  {
    title: 'Escondidos',
    content: 'A resposta está escondida dentro de uma sequência de letras.',
    indicators: ['escondido', 'contido', 'dentro de', 'oculto', 'no meio de'],
    example: {
      clue: 'O comércio está escondido no meio dos bárbaros" (3)',
      answer: 'BAR',
      explanation: 'A palavra BAR está escondida na palavra bárbaros.'
    }
  },
  {
    title: 'Reversões',
    content: 'Inverta a ordem das letras.',
    indicators: ['de ré', 'ao contrário', 'invertido', 'de trás pra frente', 'revertido'],
    example: {
      clue: 'De ré, subi no meio de transporte (6)',
      answer: 'ONIBUS',
      explanation: '"subi no" de ré (ao contrário) é igual a um meio de transporte.'
    }
  },
  {
    title: 'Substituições',
    content: 'Troque uma palavra por um sinônimo ou abreviação.',
    indicators: ['substitua', 'troque', 'por', 'abreviação', 'sinônimo'],
    example: {
      clue: 'Em Roma, 3 x 1001 era desculpa (6)',
      answer: 'MIMIMI',
      explanation: 'Substitua 1001 por seu numeral romano (MI) três vezes e terá um sinônimo de desculpa.'
    }
  },
  {
    title: 'Inserções',
    content: 'Coloque uma palavra dentro de outra.',
    indicators: ['dentro de', 'envolve', 'contém', 'abraça', 'inserido em'],
    example: {
      clue: 'Videogame é uma figura geométrica que abraça o sol (7)',
      answer: 'CONSOLE',
      explanation: 'Insira "sol" dentro de "cone" para formar um videogame.'
    }
  },
  {
    title: 'Deleções',
    content: 'Remova letras ou partes de uma palavra.',
    indicators: ['sem', 'retire', 'remova', 'exclua', 'falta', 'perdeu'],
    example: {
      clue: 'Fofocas sem pé e nem cabeça são o bicho (4)',
      answer: 'FOCA',
      explanation: 'Removendo a cabeça (início) e o pé (final) de "fofocas" temos foca, um bicho.'
    }
  },
  {
    title: 'Homófonos',
    content: 'A resposta soa igual a outra palavra.',
    indicators: ['ouvido', 'dito', 'falado', 'em voz alta', 'soa como'],
    example: {
      clue: 'Diz-se que o assento é onde ficam os presos (4)',
      answer: 'CELA',
      explanation: 'Homófono de "sela" (o assento) é um lugar em que ficam os presos.'
    }
  }
];

function Accordion({ title, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{
      marginBottom: '1rem',
      border: '2px solid #2c2c2c',
      borderRadius: 0,
      boxShadow: '3px 3px 0px rgba(0,0,0,0.3)'
    }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          width: '100%',
          textAlign: 'left',
          background: '#2c2c2c',
          color: '#f8f8f6',
          border: 'none',
          borderRadius: 0,
          padding: '0.7rem 1rem',
          fontSize: '1.08rem',
          fontWeight: 700,
          fontFamily: "'Times New Roman', Times, serif",
          textTransform: 'uppercase',
          letterSpacing: '1px',
          cursor: 'pointer',
          outline: 'none',
        }}
        aria-expanded={open}
      >
        {title} {open ? '▲' : '▼'}
      </button>
      {open && (
        <div style={{
          background: '#f8f8f6',
          padding: '1rem',
          borderRadius: 0,
          fontFamily: "'Times New Roman', Times, serif",
          color: '#2c2c2c'
        }}>
          {children}
        </div>
      )}
    </div>
  );
}

function Instructions() {
  return (
    <div className="App-container">
      <h2 style={{ marginBottom: '1rem' }}>Como Jogar</h2>
      <div className="hint-box" style={{ maxWidth: 400, margin: '0 auto', textAlign: 'left' }}>
        <p style={{
          marginBottom: '1rem',
          fontFamily: "'Times New Roman', Times, serif",
          color: '#2c2c2c',
          lineHeight: '1.6'
        }}>
          Cada pista encriptada tem duas partes: <b style={{ fontFamily: "'Times New Roman', Times, serif", fontWeight: 700 }}>definição</b> 
          (uma dica direta para a resposta) e <b style={{ fontFamily: "'Times New Roman', Times, serif", fontWeight: 700 }}>jogo de palavras</b> 
          (um jeito criativo de construir a resposta usando truques com letras e linguagem).<br/>
          O jogo de palavras geralmente envolve <b style={{ fontFamily: "'Times New Roman', Times, serif", fontWeight: 700 }}>sopa de letras</b> 
          (as letras e palavras a serem manipuladas) e <b style={{ fontFamily: "'Times New Roman', Times, serif", fontWeight: 700 }}>indicador</b> 
          (palavras que dizem o que fazer com o sopa de letras).
        </p>
        <p style={{
          marginBottom: '1.2rem',
          fontFamily: "'Times New Roman', Times, serif",
          color: '#2c2c2c',
          lineHeight: '1.6'
        }}>
          Abaixo estão os principais tipos de jogos usados nas pistas. Clique para ver exemplos e explicações:
        </p>
        {indicators.map(item => (
          <Accordion key={item.title} title={item.title} defaultOpen={false}>
            <div style={{ margin: 0, paddingLeft: '0.2rem' }}>
              <div style={{
                fontFamily: "'Times New Roman', Times, serif",
                color: '#2c2c2c',
                lineHeight: '1.6'
              }}>{item.content}</div>
              {item.indicators && (
                <div style={{
                  margin: '0.7rem 0 0.3rem 0',
                  fontSize: '0.97rem',
                  color: '#2c2c2c',
                  fontFamily: "'Times New Roman', Times, serif"
                }}>
                  <b style={{ fontWeight: 700 }}>Indicadores comuns:</b> {item.indicators.join(', ')}
                </div>
              )}
              {item.example && <ExampleBox example={item.example} />}
            </div>
          </Accordion>
        ))}
        <p class='footer-instructions'>
          O segredo é praticar, se divertir e não ter medo de errar!
        </p>
        <p class='footer-instructions'>
          Se precisa de mais uma ajudinha para resolver,{" "}
          <a href="https://www.tiktok.com/@criptico.puzzle?_t=ZM-8zOqVwmOET8&_r=1" target="_blank" rel="noopener noreferrer"
             style={{ color: '#2c2c2c', textDecoration: 'underline' }}>
            clique aqui 
          </a> para ver o nosso perfil no TikTok, onde nós postamos as soluções passadas.
        </p>
        <p class='footer-instructions'>
          Se deseja contribuir com novas pistas,{" "}
          <a href="https://forms.gle/M2v9YJhABowhxgEM9" target="_blank" rel="noopener noreferrer"
             style={{ color: '#2c2c2c', textDecoration: 'underline' }}>
            clique aqui 
          </a> para enviar suas sugestões.
        </p>
        <p class='footer-instructions'>
          Caso encotre algum erro, contate-nos através do e-mail {' '}
          <a href="mailto:lamcsoftware@gmail.com" style={{ color: '#2c2c2c', textDecoration: 'underline' }}>
            lamcsoftware@gmail.com
          </a>
        </p>
      </div>
    </div>
  );
}

export default Instructions;